<template>
  <el-dialog title="添加开屏素材" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" width="640px">
    <el-form size="small" ref="form" :model="form" label-width="130px">
      <el-form-item label="名称" required>
        <el-input v-model="form.title" placeholder="后台备注，如：618活动开屏"></el-input>
      </el-form-item>
      <el-form-item label="开屏图片" required>
        <el-button @click="chooseImg">选择图片</el-button>
        <img class="mt10 splash-preview" v-if="form.image_url" v-img-url="form.image_url">
        <div class="tips">建议 750×1334 或 1080×1920，jpg/png</div>
      </el-form-item>
      <el-form-item label="发布状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">已发布</el-radio>
          <el-radio :label="0">草稿</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="平台">
        <el-radio-group v-model="form.platform">
          <el-radio label="all">全部</el-radio>
          <el-radio label="android">Android</el-radio>
          <el-radio label="ios">iOS</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 前台未使用
      <el-form-item label="展示秒数">
        <el-input-number v-model="form.duration" :min="1" :max="30"></el-input-number>
      </el-form-item>
      -->
      <el-form-item label="允许跳过">
        <el-radio-group v-model="form.skip_enabled">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否（强制观看）</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="优先级">
        <el-input-number v-model="form.sort" :min="0" :max="9999"></el-input-number>
        <span class="tips-inline">越大越优先</span>
      </el-form-item>
      <el-form-item label="生效开始">
        <el-date-picker v-model="form.start_time_ms" type="datetime" placeholder="不限" value-format="timestamp" clearable></el-date-picker>
      </el-form-item>
      <el-form-item label="生效结束">
        <el-date-picker v-model="form.end_time_ms" type="datetime" placeholder="不限" value-format="timestamp" clearable></el-date-picker>
      </el-form-item>
      <el-form-item label="点击跳转">
        <el-radio-group v-model="form.link_type">
          <el-radio :label="0">无</el-radio>
          <el-radio :label="1">外链/H5</el-radio>
          <el-radio :label="2">APP内页</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="跳转地址" v-if="form.link_type > 0">
        <el-input v-model="form.link_url" :placeholder="form.link_type == 2 ? '/pages/xxx/xxx' : 'https://...'"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit">确定</el-button>
    </div>
    <Upload v-if="isupload" :isupload="isupload" :config="{ total: 1 }" @returnImgs="returnImgsFunc"></Upload>
  </el-dialog>
</template>

<script>
import AppSettingApi from '@/api/appsetting.js';
import Upload from '@/components/file/Upload';

export default {
  components: { Upload },
  props: ['open'],
  data() {
    return {
      dialogVisible: false,
      loading: false,
      isupload: false,
      form: {
        title: '',
        image_url: '',
        status: 1,
        platform: 'all',
        duration: 3,
        skip_enabled: 1,
        sort: 0,
        start_time_ms: null,
        end_time_ms: null,
        link_type: 0,
        link_url: ''
      }
    };
  },
  watch: {
    open(n) {
      if (n) {
        this.dialogVisible = true;
        this.resetForm();
      }
    }
  },
  methods: {
    resetForm() {
      this.form = {
        title: '',
        image_url: '',
        status: 1,
        platform: 'all',
        duration: 3,
        skip_enabled: 1,
        sort: 0,
        start_time_ms: null,
        end_time_ms: null,
        link_type: 0,
        link_url: ''
      };
    },
    chooseImg() { this.isupload = true; },
    returnImgsFunc(e) {
      this.isupload = false;
      if (e && e[0]) this.form.image_url = e[0].file_path;
    },
    buildParams() {
      const p = Object.assign({}, this.form);
      p.start_time = p.start_time_ms ? Math.floor(p.start_time_ms / 1000) : 0;
      p.end_time = p.end_time_ms ? Math.floor(p.end_time_ms / 1000) : 0;
      delete p.start_time_ms;
      delete p.end_time_ms;
      return p;
    },
    onSubmit() {
      if (!this.form.image_url) {
        this.$message.warning('请上传开屏图片');
        return;
      }
      this.loading = true;
      AppSettingApi.addAppSplash(this.buildParams(), true)
        .then(() => {
          this.loading = false;
          this.$message.success('添加成功');
          this.dialogFormVisible(true);
        })
        .catch(() => { this.loading = false; });
    },
    dialogFormVisible(ok) {
      this.dialogVisible = false;
      this.$emit('close', { type: ok ? 'success' : 'error', openDialog: false });
    }
  }
};
</script>

<style scoped>
.tips { color: #999; font-size: 12px; margin-top: 4px; }
.tips-inline { color: #999; font-size: 12px; margin-left: 8px; }
.splash-preview { display: block; max-width: 120px; max-height: 200px; margin-top: 8px; border-radius: 4px; }
</style>



// WEBPACK FOOTER //
// src/views/appsetting/appopen/part/splash/Add.vue